export const getStatus = (isGuest, isAdmin, userStatus, profileExist, profileStatus, isSubmitted, profileDisabled, adminDisabled) => {
  if(isAdmin) {
    return {
      profile : 'Approved',
      profileStatus:'approved',
      profileColor : 'success',
      showActivate : false
    }
  }
  
  // Check if profile is disabled by admin (highest priority)
  if(adminDisabled) {
    return {
      profile : 'Disabled by Admin',
      profileStatus:'admin-disabled',
      profileColor : 'error',
      showActivate : true
    }
  }
  
  // Check if profile is hidden by user
  if(profileDisabled) {
    return {
      profile : 'Hidden by User',
      profileStatus:'user-hidden',
      profileColor : 'warning',
      showActivate : true  // Admin can override user's self-disable
    }
  }
  if(userStatus < 0) {
    return {
      profile : 'Not verified',
      profileStatus:'not-verified',
      profileColor : 'primary',
      showActivate : false
    }
  }
  if(userStatus == 2) {
    return {
      profile : 'Disabled',
      profileStatus:'disabled',
      profileColor : 'error',
      showActivate : true
    }
  }
  if(isGuest) {
    if(userStatus == 0) {
      return {
        profile : 'Pending approval',
        profileStatus:'pending',
        profileColor : 'warning',
        showActivate : true
      }
    } else {
      return {
        profile : 'Approved',
        profileStatus:'approved',
        profileColor : 'success',
        showActivate : true
      }
    }
  }
  // Check if profile is pending approval (submitted but not yet approved)
  if(isSubmitted && profileStatus === 0) {
    return {
      profile : 'Pending approval',
      profileStatus:'pending',
      profileColor : 'warning',
      showActivate : true
    }
  }
  // Check if both user and profile are approved
  else if(userStatus === 1 && profileStatus === 1) {
    return {
      profile : 'Approved',
      profileStatus:'approved',
      profileColor : 'success',
      showActivate : true
    }
  }
  // Check if profile is in draft state
  else if(userStatus === 0 || profileStatus === 0) {
    if(isSubmitted) {
      return {
        profile : 'Pending approval',
        profileStatus:'pending',
        profileColor : 'warning',
        showActivate : true
      }
    } else {
      return {
        profile : 'Draft',
        profileStatus:'draft',
        profileColor : 'primary',
        showActivate : profileExist
      }
    }
  } else {
    return {
      profile : 'Draft',
      profileStatus:'draft',
      profileColor : 'primary',
      showActivate : false
    }
  }
}